import { useContext } from 'react';
import { DeviceEnrollContext, type DeviceEnrollContextValue } from './DeviceEnrollContext';

export function useDeviceEnrollState(): DeviceEnrollContextValue {
  const ctx = useContext(DeviceEnrollContext);
  if (!ctx) throw new Error('useDeviceEnrollState must be used inside <DeviceEnrollProvider>');
  return ctx;
}
